// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"161":"7f8badc4919ad59f","349":"e951d92539aab53d","405":"686aca272bda0f41","888":"5c706986fb7db8ef"}[chunkId] + ".css";
};